import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DcpPageIndexComponent} from './dcp-page-index.component';
import {ConfigModule} from '@spartacus/core';

@NgModule({
  exports: [DcpPageIndexComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        PageIndexComponent: {
          component: DcpPageIndexComponent,
        },
      },
    }),
    DcpPageIndexComponent,
  ],
})
export class DcpPageIndexModule {}
